// src/pages/Floz.tsx
import React from "react";
import Logo from "../../Assets/Images/floz_logo.svg";

const FlozLogin = () => {
  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center px-4 md:px-8"
    >
      {/* Login Card */}
      <div className="bg-white p-12 rounded-xl shadow-2xl border border-gray-200 w-full max-w-md space-y-6">
        {/* Logo */}
        <div className="flex justify-center py-2">
          <img src={Logo} alt="Floz Logo" className="h-16 w-auto" />
        </div>

        {/* Email Field */}
        <div>
          <label className="block">
            <span className="after:content-['*'] after:ml-0.5 after:text-red-500 text-sm font-medium text-slate-700">
              Email
            </span>
            <input
              type="email"
              name="email"
              className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-4 py-3 text-sm placeholder-slate-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
              placeholder="Enter your Email"
              required
              autoComplete="off"
            />
          </label>
        </div>

        {/* Password Field */}
        <div>
          <label className="block">
            <span className="after:content-['*'] after:ml-0.5 after:text-red-500 text-sm font-medium text-slate-700">
              Password
            </span>
            <input
              type="password"
              name="password"
              className="mt-1 block w-full rounded-md border border-slate-300 bg-white px-4 py-3 text-sm placeholder-slate-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
              placeholder="Enter your password"
              required
              autoComplete="off"
            />
          </label>
        </div>

        {/* Sign In Button */}
        <div className="pt-4">
          <button className="w-full bg-teal-500 hover:bg-teal-600 text-white font-medium text-lg py-3 rounded-md transition duration-200 shadow-md">
            SIGN IN
          </button>
        </div>
      </div>

      {/* Contact Info */}
      {/* <div className="mt-12 text-center">
        <p className="text-2xl md:text-3xl font-bold">
          <span className="text-gray-700">For Access to </span>
          <span className="text-teal-600">Floz</span>
          <br />
          <span className="text-gray-700">Please Contact Us: </span>
          <a
            href="mailto:info@watersprint.uk"
            className="text-teal-600  underline transition font-medium"
          >
            info@watersprint.uk
          </a>
        </p>
      </div> */}
    </div>
  );
};

export default FlozLogin;